<template>
    <div class="content-wrapper primary-table">
        <div class="row">
            <div class="col-sm-12 d-md-none">
                <app-breadcrumb :page-title="$t('talentpool')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>

            <button type="button"
                    class="btn btn-primary btn-circular btn-with-shadow top-corner-add-button"
                    data-toggle="modal"
                    @click="openAddEditModal">
                <app-icon :name="'user-plus'" width="22" height="22"/>

            </button>


        </div>

        <app-table
            :id="tableId"
            :options="options"
            :filtered-data="filteredData"
            @getRows="getSelectedRows"
            @getRowsAction="getSelectedRowsAction"
            @getAddButtonAction="openAddEditModal"
            @action="getListAction"
        />




        <app-candidate-add-modal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            :modal-type="modalType"
            @close-modal="closeAddEditModal"
            @close-and-open-modal="closeAddEditModalAndOpen"
        />

        <app-rejection-modal
            v-if="rejectionModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            modal-id="rejection-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeRejectionModal"
        />

        <app-schedule-modal
            v-if="scheduleModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            :timeline-states="this.options.timelineState"
            :jobOptions="this.options.topBarFilters[0].option"
            modal-id="schedule-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeScheduleModal"
        />

        <app-share-modal
            v-if="shareModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            :timeline-states="this.options.timelineState"
            modal-id="notification-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeShareModal"
        />

        <app-message-modal
            v-if="messageModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            :timeline-states="this.options.timelineState"
            :jobOptions="this.options.topBarFilters[0].option"
            modal-id="message-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeMessageModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            :subTitle="$t('Candidate')"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHiringHelpers} from './mixins/TableHiringHelpers';

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableHiringHelpers],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            shareModalActive: false,
            messageModalActive: false,
            rejectionModalActive: false,
            scheduleModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            selectedCandidates: '',
            modalType: 'add-edit-modal',
            tableId: 'talentpool',
            filteredData: {
                name: '',
            },
            rowData: {},
            options: {
                name: 'TalentpoolTable',
                url: actions.DATATABLE_CANDIDATES_DATA,
                showHeader: true,
                showFooter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit-3',
                        type: 'none',
                        className: 'edit',
                        component: 'app-candidate-add-modal',
                        modalId: 'add-edit-Modal',

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                    },

                ],

                topBarFilters: [

                    {
                        "title": this.$t('Job'),
                        "type": "drop-down-filter",
                        "key": "filter-with-job",
                        "option": [],
                        "initValue": this.getDefaultJob()
                    },

                ],
                filters: [

                    {
                        "title": this.$t('tag'),
                        "type": "drop-down-filter",
                        "key": "filter-with-tag",
                        "option": [],
                    },
                    {
                        "title": this.$t('skills'),
                        "type": "drop-down-filter",
                        "key": "filter-with-skill",
                        "option": [],
                    },


                    {
                        "title": "ID",
                        "type": "hidden",
                        "key": "filter-with-candidate-id",
                        "initValue": this.getDefaultCandidate(),
                        "option": [],
                    },
                    {
                        "title": "Status",
                        "type": "hidden",
                        "key": "filter-with-status",
                        "initValue": 1, // 3=onboarding, 2=hiring, 1=talentpool
                        "option": [],
                    },


                    {
                        "title": this.$t('residence'),
                        "type": "drop-down-filter",
                        "key": "filter-with-residence",
                        "option": [
                            {id: '1', value: 'Praha - CitySense'},
                        ],
                        // "option": [
                        //     {id: '1', value: 'Praha - Stodůlky (701)'},
                        //     {id: '2', value: 'Praha - Smíchov (702)'},
                        //     {id: '3', value: 'Ostrava (703)'},
                        //     {id: '4', value: 'Brno (704)'},
                        //     {id: '5', value: 'Pardubice (705)'},
                        //     {id: '6', value: 'Zlín (706)'},
                        //     {id: '7', value: 'České Budějovice (707)'},
                        //     {id: '8', value: 'Plzeň (708)'},
                        //     {id: '9', value: 'Chomutov (709)'},
                        // ],
                        "header": {
                            "title": this.$t('want_to_filter_your_list'),
                            "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
                        },
                    },
                    {
                        "title": this.$t('start_salary'),
                        "type": "range-filter",
                        "key": "salary-range",
                        "maxTitle": this.$t('max'),
                        "minTitle": this.$t('min'),
                        "sign": "Kč"
                    },
                    {
                        "title": this.$t('application_date'),
                        "type": "range-picker",
                        "key": "date",
                        "option": [
                            "today", "thisMonth", "last7Days"
                        ]
                    },
                    {
                        "title": this.$t('rating'),
                        "type": "range-filter",
                        "key": "rating-range",
                        "maxTitle": this.$t('max'),
                        "minTitle": this.$t('min'),
                        "sign": " ★",
                        "maxRange": 3,
                        "minRange": 0

                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 5,
                showAction: true,
                actionSelectOptions: [
                    {id: '1', value: this.$t('delete_candidate')},
                    {id: '2', value: this.$t('share_with_manager')},
                    {id: '6', value: this.$t('send_message')},
                    // {id: '3', value: this.$t('change_state...')},
                    {id: '4', value: this.$t('start_hiring')},
                    // {id: '5', value: this.$t('start_onboarding')},
                ],
                actionSelectedOption: 1,
                orderBy: 'desc',
                actionType: "default",
                tableShadow: false,
                emptyText: this.$t('nothing_to_show_here_hiring'),
                showEmptyAnimation: true,
                showComments: true,
                showTopBar: true,
                showTimeline: false,
                showAddButton: true,
                datatableParentId: 1, // 3=onboarding, 2=hiring, 1=talentpool
                // actionType: "dropdown",
                enableRowSelect: true,
                // tablePaddingClass: 'p-primary'
                tableClass: 'primary-table',


            },

        }
    },
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();

        /**
         * for open modal after clicking on notification and etc.
         */
        if(this.getDefaultCandidate()){
            if(this.getDefaultCandidate() == 'new'){
                this.selectedUrl = ``;
            } else {
                this.selectedUrl = `${actions.DATATABLE_CANDIDATES_DATA}/${this.getDefaultCandidate()}`;
            }

            this.openAddEditModal();
        }
    },
    methods: {
        /**
         * for open modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openRejectionModal() {
            this.rejectionModalActive = true;
        },
        openScheduleModal() {
            this.scheduleModalActive = true;
        },
        openShareModal() {
            this.shareModalActive = true;
        },
        openMessageModal() {
            this.messageModalActive = true;
        },
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * for close modal
         */
        closeAddEditModal() {
            $("#add-edit-Modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();

            // Add page after visited candidate to history
            if (history.replaceState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.replaceState({path:newurl},'',newurl);
            }
        },
        closeRejectionModal() {
            this.rejectionModalActive = false;
            this.reSetData();
        },
        closeScheduleModal() {
            this.scheduleModalActive = false;
            this.reSetData();
        },
        closeShareModal() {
            this.shareModalActive = false;
            this.reSetData();
        },
        closeMessageModal() {
            this.messageModalActive = false;
            this.reSetData();
        },
        closeAddEditModalAndOpen(modal, candidate) {
            this.closeAddEditModal();

            if(modal == 'notification'){
                this.selectedRows = candidate;
                this.openShareModal();
            } else if (modal == 'rejection'){
                this.selectedRows = candidate;
                this.openRejectionModal();
            } else if (modal == 'schedule'){
                this.selectedRows = candidate;
                this.openScheduleModal();
            }

        },


        /**
         * for open/close filters
         */
        toggleFilters() {
            $('.filters-bar').slideToggle();
        },


        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('start_hiring')) {
                this.selectedRows = [{"id": rowData.id, "email": rowData.email, "name": rowData.name, "timeline_state": 1, "job": rowData.job},];
                this.changeToNextState();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.DATATABLE_CANDIDATES_DATA}/${rowData.id}`;
                this.openAddEditModal();
            }
        },


        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_CANDIDATES_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {

            this.axiosGet(actions.TAGS_DATA).then(response => {
                let tag = this.options.filters.find(element => element.key === "filter-with-tag");

                tag.option = response.data.data.map(tag => {
                    return {
                        id: tag.id,
                        value: tag.name,
                        color: tag.color
                    }
                });


            });

            this.axiosGet(actions.SKILLS_DATA).then(response => {
                let skill = this.options.filters.find(element => element.key === "filter-with-skill");

                skill.option = response.data.data.map(skill => {
                    return {
                        id: skill.id,
                        value: skill.value
                    }
                });


            });

            this.axiosGet(actions.JOBS_DATA).then(response => {
                let job = this.options.topBarFilters.find(element => element.key === "filter-with-job");

                job.option = response.data.map(job => {
                    return {
                        id: job.id,
                        value: job.job
                    }
                });


            });

        },

        /**
         * Change to hiring state 1
         */
        changeToNextState(){
            this.options.actionSelectedOption = 4;
            this.getSelectedRowsAction();
        },

        /**
         * Show Datatable Filter by last job I have visited / by parameters in URL
         */
        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },
        getCookie(name) {
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return match ? match[1] : null;
        },
        getDefaultJob(){
            let selectedJob = '';

            if(location.href.indexOf("profile=") >= 0){
                selectedJob = parseInt(this.getUrlParameter('job', location.href));
            }

            return selectedJob;
        },
        getDefaultCandidate(){
            if(location.href.indexOf("?profile") >= 0){
                return parseInt(this.getUrlParameter('profile', location.href));
            } else if (location.href.indexOf("?new") >= 0){
                return 'new';
            }
        },

        /**
         * get Selected Rows
         */
        getSelectedRows(value) {
            this.selectedRows = value;
        },

        /**
         * do Selected Action with Selected Rows
         */
        getSelectedRowsAction() {
            // @todo: move to AdvanceDatatableTalentpool
            if (this.options.actionSelectedOption == 1) {
                this.openRejectionModal();

            } else if (this.options.actionSelectedOption == 2) {
                this.openShareModal();

            } else if (this.options.actionSelectedOption == 6) {
                this.openMessageModal();

            } else if (this.options.actionSelectedOption == 3) {
                this.$hub.$emit('reload-' + this.tableId);
                this.$toastr.s(this.$t('candidate_status_changed'));


            } else if (this.options.actionSelectedOption == 4) {

                let candidateIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });

                let selectedBulkEditData = {
                    candidate_id: Object.values(candidateIds).join(","),
                    status: 2,
                    timeline_state: 1
                };

                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });


            } else if (this.options.actionSelectedOption == 5) {

                let candidateIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });

                let selectedBulkEditData = {
                    candidate_id: Object.values(candidateIds).join(","),
                    status: 3,
                    timeline_state: 7
                };

                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });

            } else {
                console.log('Vybrana jina akce: '+this.options.actionSelectedOption);

            }
        },

        afterSuccess(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },
        afterError(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },


        /**
         * get Status Filter
         */
        getSearchValue(value) {
                let instance = this;
                this.search = value;
                setTimeout(function () {
                    instance.$hub.$emit('reload-' + instance.tableId);
                });
            },
            getFilterValue(item) {
                this.filteredData.status = item;
                console.log('test '+item);
                this.$hub.$emit('reload-'+this.tableId);
            }

    },
}
</script>
